import React, { useEffect, useState } from "react";
import styles from "./BackToTop.module.scss";
import classNames from "classnames";

export const BackToTopComponent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div
      className={classNames(styles["backToTop"], {
        [styles["visible"] as string]: isVisible,
      })}
      onClick={scrollToTop}
      aria-label="Back to top">
      <svg viewBox="0 0 24 24">
        <path d="M12 4l-8 8h6v8h4v-8h6z" />
      </svg>
    </div>
  );
};
